/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：Vue 初期化
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/29 ノア）虞
 *
 */
import Vue from 'vue'
import { VTooltip } from 'v-tooltip'
import VueLogger from 'vuejs-logger'
import './plugins/element'
import './icons'

import './assets/css/index.scss'
import 'v-tooltip/dist/v-tooltip.css'
import { i18n } from './locales'
import App from './App.vue'
import router from './router'
import store from './store'
import { loadingService } from './commons/services/loadingService'
import { msgBoxService } from './commons/services/msgBoxService'

/**
 * Vue 初期化
 */
;(async (): Promise<void> => {
  Vue.config.productionTip = false

  // Init VueLogger
  const isProduction = process.env.NODE_ENV === 'production'
  const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Vue.use(VueLogger as any, options)

  // Init EventBus
  Vue.prototype.$EventBus = new Vue()

  // Init LoadingService
  Vue.prototype.$loadingService = loadingService

  // Init MsgBoxService
  Vue.prototype.$msgBoxService = msgBoxService

  Vue.directive('tooltip', VTooltip)

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})()
